export interface ErrorMessageDefinition {
  type: string;
  message: string;
}

export const REDIRECT_ERROR_MESSAGES: ErrorMessageDefinition[] = [
  { type: 'invalid_url', message: 'The confirmation link is invalid or malformed. Please check the link and try again.' },
  { type: 'token_expired', message: 'This confirmation link has expired due to time limits or too many failed attempts. Please submit your email again.' }
];

export function getErrorMessage(type: string | null): string {
  if (!type) return 'An unexpected error occurred.';
  const found = REDIRECT_ERROR_MESSAGES.find(e => e.type.toLowerCase() === type.toLowerCase());
  return found ? found.message : 'An unexpected error occurred.';
}
